import { Component, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { navItems } from '../../_nav';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent implements OnDestroy {
  public navItems = navItems;
  loginUser = "";
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  constructor(
    private router: Router,
    private cookieService: CookieService,
	@Inject(DOCUMENT) _document?: any
  ) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });
    this.loginUser = this.cookieService.get("UserName");
  }
  
  onLogout()
  {
    /*
    this.cookieService.delete("loginUser",);
    this.cookieService.delete('currentUser');
    this.cookieService.delete('loginToken');
    */
    this.cookieService.set('currentUser', '', null, null, null, true, "Strict");
    this.cookieService.set('loginToken', '', null, null, null, true, "Strict");
    this.cookieService.set('loginUser', '', null, null, null, true, "Strict");

	  this.router.navigate(['/login']);
  }
  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}
